import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import PayPal from '../../../shared/components/payments/paypal';

const PageWrapper = styled.div`
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f6f8fa;
`;

const Header = styled.div`
  font-size: 1.3em;
  font-weight: 600;
  margin-bottom: 20px;
  text-align: center;
  color: #333;
  
`;



const PlanOptions = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
`;

const PlanCard = styled.div`
  background: #fff;
  border: 2px solid ${({selected}) => selected ? '#007bff' : '#ccc'};
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .1);
  padding: 20px;
  width: 500px;
  cursor: pointer;
  transition: background-color 0.3s, border-color 0.3s;

  &:hover {
    background-color: #f0f0f0;
    border-color: #007bff;
  }
`;

const PlanTitle = styled.div`
  margin-bottom: 15px;
  font-weight: bold;
`;

const Price = styled.div`
  font-size: 1.25em;
  font-weight: bold;
  margin-bottom: 10px;
  color: #007bff;
`;

const Frequency = styled.div`
  font-size: 0.9em;
  color: #666;
`;

const Summary = styled.div`
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .1);
  padding: 20px;
  margin-top: 20px;
  width: 40%;   // Adjusted for wider and consistent width
  min-width: 350px; // Ensures the width doesn't become too narrow
  max-width: 500px; // Prevents the summary from being excessively wide on larger screens
  align-self: center;
`;

const SummaryItem = styled.div`
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  font-size: 0.9em;
`;

const Total = styled(SummaryItem)`
  font-weight: bold;
  font-size: 1em;
`;
const BlueHeadline = styled.div`
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 10px 20px;
  margin-bottom: 20px;
  color: #007bff; // Adjust the color as needed
  font-size: 1.3em;
  text-align: center;

  &:hover, &:focus {
    background-color: transparent;
    color: #007bff; // Change as per your hover effect need
    text-decoration: none;
  }
`;

const DropDown = styled.select`
  padding: 10px;
  margin-bottom: 10px;
  width: 100%;
  font-size: 1em;
`;
const SubscriptionPage = () => {
  const [selectedPlan, setSelectedPlan] = useState('monthly');
  const [selectedQuantity, setSelectedQuantity] = useState(1);


  const planDetails = {
    monthly: {
      title: "Monthly Plan",
      price: 12,
      frequency: "per Maximum of 500 feedback notes / month",
      description: "Billed monthly"
    },
    yearly: {
      title: "Yearly Plan",
      price: 10,
      frequency: "per member / month",
      description: "Pay for 12 months upfront and save"
    }
  };

  const selectedPlanDetails = planDetails[selectedPlan];

  //total should be quantity multiplied by 12
   const total = useMemo(() => {
    // Expensive computation or operation based on 'data'
    return selectedPlanDetails.price *selectedQuantity
  }, [selectedQuantity,selectedPlanDetails]); // The dependency array containing 'data'


  const generateOptions = () => {
    const options = [];
    for (let i = 500; i <= 40000; i += 500) { // Assuming each step is 500
      options.push(<option key={i} value={i/500}>{i}</option>); // Using `i/500` to match your value setting for each step
    }
    return options;
  };
  return (
    <PageWrapper>
     <BlueHeadline>Welcome to Our Community!</BlueHeadline>
      <PlanOptions>

      <PlanCard selected={true}>
        <Header>Pay for {selectedPlanDetails.title}</Header>
        <SummaryItem>
           <Frequency>Select max number of feedback notes per month</Frequency>
           <DropDown value={selectedQuantity} onChange={(e) => setSelectedQuantity(parseInt(e.target.value, 10))}>
           {generateOptions()}
        {/* You can add more options or generate these dynamically */}
      </DropDown>
        </SummaryItem>
          <SummaryItem>
          <div>Users</div>
          <div>Unlimited</div>
        </SummaryItem>
        <SummaryItem>
          <div>Price</div>
          <div>${selectedPlanDetails.price}</div>
        </SummaryItem>
        <SummaryItem>
          <div>Billing Frequency</div>
          <div>{selectedPlanDetails.description}</div>
        </SummaryItem>
          <SummaryItem>
          <div>Max number of monthly feedback notes</div>
          <div>{selectedQuantity * 500}</div>
        </SummaryItem>
        <SummaryItem>
          <div>Total Cost</div>
          <div>${total} {selectedPlan === 'yearly' ? '/ YEAR' : '/ MONTH'}</div>
        </SummaryItem>
        <Total>
          <div>Total Due Today</div>
          <div>${total}</div>
        </Total>

        <PayPal payment_terms={selectedPlan} quantity={selectedQuantity} />
      </PlanCard>
        </PlanOptions>
    </PageWrapper>
  );
};

export default SubscriptionPage;